import { sendRequest } from '../../common/utils';
import { getLocale } from '../../providers';

export const fetchUsersPaginated = ({ userId, params }) => {
    const { requestBody } = params;
    const lang = getLocale();
    const url = `/users/${lang}`;
    return sendRequest({
        url,
        method: 'POST',
        body: {
            ...requestBody,
            userId: userId,
        },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, extraInfo: error.extraInfo, code: error.code } };
        });
};

export const impersonateUser = ({ userID }) => {
    const url = `/users/${userID}/impersonation`;
    return sendRequest({
        url,
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, extraInfo: error.extraInfo, code: error.code } };
        });
};
